import styled from "styled-components";

const SCFooter = styled.div`
  position: absolute;
  bottom: 20px;
  text-align: center;

  p {
    margin: 0px;
  }

  p > a{
    color: #fff;
    font-size: 0.8rem;
  }
`;

export {
  SCFooter
};